function FAQ() {}
export default FAQ;
